import type { ServiceOperation } from '../api'
import type { TagType } from '../theme'

export interface OperationView {
  label: string
  statusText: string
  tagType: TagType
  busy: boolean
}

export function operationLabel(op: ServiceOperation): string {
  switch (op.kind) {
    case 'start':
      return '启动'
    case 'stop':
      return '停止'
    case 'restart':
      return '重启'
    case 'rollback':
      return '回滚'
    case 'idle':
      return '空闲'
    default:
      return '部署'
  }
}

export function operationStatusText(op: ServiceOperation): string {
  if (op.status === 'idle' || op.kind === 'idle') {
    return '空闲'
  }

  const label = operationLabel(op)
  switch (op.status) {
    case 'running':
      return `${label}中`
    case 'success':
      return `${label}成功`
    case 'failed':
      return `${label}失败`
    case 'cancelled':
      return `${label}已取消`
    default:
      return '空闲'
  }
}

export function operationTagType(op: ServiceOperation): TagType {
  switch (op.status) {
    case 'running':
      return 'info'
    case 'success':
      return 'success'
    case 'failed':
      return 'error'
    case 'cancelled':
      return 'warning'
    default:
      return 'default'
  }
}

export function isOperationBusy(op: ServiceOperation): boolean {
  return op.status === 'running'
}

export function toOperationView(op: ServiceOperation): OperationView {
  return {
    label: operationLabel(op),
    statusText: operationStatusText(op),
    tagType: operationTagType(op),
    busy: isOperationBusy(op),
  }
}
